import axios from 'axios'
import { getErrorMessage } from './getErrorMessage'

// Function to wrap FileReader in a promise
const readBlobAsText = (blob: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.addEventListener('error', reject)
    reader.readAsText(blob)
  })

export const getErrorMessageFromPossibleBlob = async (
  error: unknown,
  handleUnknownError = (_e: unknown) => {},
) => {
  // Une requête `responseType: 'blob'` renvoie aussi le corps d'erreur en Blob :
  // on le parse et on réinjecte le JSON à la place du Blob, pour que la détection
  // de forme de `getErrorMessage` (422 vine, 403, 500…) puisse extraire le vrai message.
  if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
    try {
      const errorText = (await readBlobAsText(error.response.data)) as string
      error.response.data = JSON.parse(errorText)
    } catch {
      // Blob non-JSON (HTML, réseau…) → getErrorMessage renverra le fallback générique.
    }
  }

  return getErrorMessage(error, handleUnknownError)
}
